<img [src]="image"/>
<div class="label">{{'logo.present' | wording }}</div>